// extracted by mini-css-extract-plugin
export default {"printarea":"DefaultForms_printarea__BpezC","rowItem":"DefaultForms_rowItem__dswFp"};